import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const navLinks = [
    { label: "O nas", id: "o-nas" },
    { label: "Oferta", id: "oferta" },
    { label: "Galeria", id: "galeria" },
    { label: "Kontakt", id: "kontakt" }
];

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        }
        
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToSection = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
    }

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
            <div className="container mx-auto px-4 md:px-8">
                <nav className="flex items-center justify-between h-20">
                    {/* Logo */}
                    <button className="font-display text-xl md:text-2xl font-bold text-foreground" onClick={scrollToTop}>
                        Bartkiewicz<span className="text-primary"> Meble</span>
                    </button>

                    {/* Desktop Navigation */}
                    <ul className="hidden md:flex items-center gap-8">
                        {navLinks.map((link) => (
                            <li key={link.id}>
                                <button 
                                    onClick={() => scrollToSection(link.id)}
                                    className="text-foreground/80 hover:text-primary transition-colors text-sm font-medium"
                                >
                                    {link.label}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* Desktop CTA Button */}
                    <Button onClick={() => scrollToSection("kontakt")} className="hidden md:inline-flex bg-primary text-primary-foreground hover:bg-primary/90">Zamów wycenę</Button>

                    {/* Mobile Menu Button */}
                    <button 
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
                        className="md:hidden p-2 text-foreground" 
                        aria-label="Toggle Menu"
                    >
                        {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </nav>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="md:hidden bg-background border-t border-border/50 py-4">
                        <ul className="space-y-2">
                            {navLinks.map((link) => (
                                <li key={link.id}>
                                    <button
                                        onClick={() => scrollToSection(link.id)}
                                        className="block w-full text-left px-4 py-3 text-foreground/80 hover:text-primary hover:bg-primary/5 transition-colors font-medium"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="px-4 mt-4">
                            <Button
                                onClick={() => scrollToSection("kontakt")}
                                className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
                            >
                                Zamów wycenę
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Navbar;